import { queryKeys } from "../queryKeys";
import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils";

export interface EntityStats {
    totalCandidates: number;
    totalHired: number;
    totalScreened: number;
    totalEligible: number;
    questionnairesCompleted: number;
    // Application Status chart
    certificationsPending: number;
    certificationsReceived: number;
    appealPending: number;
    appealDenied: number;
    // WOTC Categories chart
    qualificationCounts: Record<string, number>;
}

export function useClientEntityStats(clientId: string, entityId: string | undefined, recurse: boolean) {
    const axios = axiosInstance();

    return useQuery({
        ...queryKeys.candidates.statsByEntity(clientId, entityId, recurse),
        queryFn: () =>
            axios.get<EntityStats>(`api/Clients/${clientId}/Entities/${entityId ?? "all"}/candidates/stats?recurse=${recurse}`).then(response => response.data),
        enabled: !!clientId && !!entityId,
    });
}
